import { Component, Inject, OnInit } from '@angular/core';
import { PopUpComponent } from '../pop-up.component';
import { Direction } from '@angular/cdk/bidi';
import { RoutePlanningService } from 'src/app/modules/route-planner/services/route-planning/route-planning.service';
import { ResizeService } from 'src/app/@shared/services/resize/resize.service';
import { Overlay } from '@angular/cdk/overlay';
import { POPUP_DATA } from 'src/app/@shared/services/modal/modal.service';
import { LanguageService } from 'src/app/@shared/services/language/language.service';
import { CLOSE } from 'src/app/modules/route-planner/constants/multi-language.constants';

@Component({
    selector: 'app-cant-find-user-location-pop-up',
    templateUrl: './cant-find-user-location-pop-up.component.html',
    styleUrl: './cant-find-user-location-pop-up.component.scss',
    standalone: false
})
export class CantFindUserLocationPopUpComponent extends PopUpComponent implements OnInit {

  direction: Direction
  closeText: string
  cantFindLocationText: string

  constructor(
      routePlanningService: RoutePlanningService,
      resizeService: ResizeService,
      overlay: Overlay,
      @Inject(POPUP_DATA)
      public readonly data: { message: {hebrew: string, english: string, arabic: string} },
      private readonly languageService: LanguageService
    ) {
      super(routePlanningService, resizeService, overlay);
    }

    override ngOnInit(): void {
      super.ngOnInit()
      this.initializeMultiLanguageTexts()
    }

  initializeMultiLanguageTexts() {
    this.languageService.selectedLanguage$.subscribe(language => {
      this.direction = language.direction
      this.closeText = CLOSE[language.language]
      this.cantFindLocationText = this.data.message[language.language]
    })
     
  }
}
